import { render } from "./NearbyPlaceDetails.vue?vue&type=template&id=67f7dc71&scoped=true"
import script from "./NearbyPlaceDetails.vue?vue&type=script&lang=js"
export * from "./NearbyPlaceDetails.vue?vue&type=script&lang=js"

import "./NearbyPlaceDetails.vue?vue&type=style&index=0&id=67f7dc71&scoped=true&lang=css"

import exportComponent from "/Users/klausdresbach/Dropbox/IT-Projekte/Web-Entwicklung/niceplaces/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67f7dc71"]])

export default __exports__